module.exports = __webpack_public_path__ + "img/6right-c546b343.png";